import * as http from 'utils/http';
import config from 'config';
import serialize from 'utils/serialize';

const getRoutes = async (params) => {
  if (!params?.journey_id) {
    throw new Error();
  }

  return await http.get(`${config.API_URL}api/delfos/historical-routes?${serialize(params)}`);
};

export { getRoutes };
